<div class="card-primary">
  <h2 mat-dialog-title>
    {{ 'vouchers.active-dialog.title' | translate | capitalize }}
  </h2>
  <p>{{ 'vouchers.active-dialog.description' | translate | capitalize }}</p>
  <mat-form-field class="full-width" appearance="outline">
    <mat-label>{{ 'voucher.voucher-code' | translate | capitalize }}</mat-label>
    <input disabled matInput [value]="data.code" />
  </mat-form-field>
  <mat-form-field class="full-width" appearance="outline">
    <mat-label>{{ 'vouchers.active-dialog.active-per' | translate | capitalize }}</mat-label>
    <input disabled matInput [value]="data.active | date: 'dd-MM-yyyy'" />
  </mat-form-field>
</div>
